// extracted by mini-css-extract-plugin
export default {"wrapper":"OV-z","ratingContainer":"PV-z","ratingValue":"QV-z","starSprite":"RV-z","ratingLabel":"SV-z","error":"TV-z","errorBox":"UV-z"};